// printers/IdeaFormerPrinter.ts
import { BasePrinter, PrinterConnectionResult } from './BasePrinter';

export class IdeaFormerPrinter extends BasePrinter {
  readonly type = 'ideaformer';

  async checkPrinterConnection(ip: string): Promise<PrinterConnectionResult> {
    try {
      const res = await this.fetchWithTimeout(
        `https://${ip}/server/info`,
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
          },
        }
      );

      return res.ok
        ? {
          ip,
          type: this.type,
          success: true,
          message: 'Printer is reachable.',
        }
        : {
          ip,
          type: this.type,
          success: false,
          message: `Failed to connect to printer. Please trust the certificate in your browser.${res.status}`,
        };
    } catch (error) {
      return {
        ip,
        type: this.type,
        success: false,
        message: this.getPrinterNetworkErrorMessage(error),
      };
    }
  }

  async sendGcodeToPrinter(
    designTitle: string,
    gcodeText: string,
    ip: string
  ): Promise<void> {
    if (!gcodeText) {
      throw new Error('No G-code provided');
    }

    try {
      const file = new File(
        [gcodeText],
        `${designTitle}.gcode`,
        { type: 'text/plain' }
      );

      const uploadData = new FormData();
      uploadData.append('file', file);
      uploadData.append('print', 'false');

    const uploadRes = await fetch(
      `https://${ip}/server/files/upload`,
      { method: 'POST', body: uploadData }
    );

      if (!uploadRes.ok) {
        throw new Error(`Failed to upload G-code. ${uploadRes.status}`);
      }

      const queueData = new FormData();
      queueData.append('filenames', `${designTitle}.gcode`);
      queueData.append('reset', 'false');

    const enqueueRes = await fetch(
      `https://${ip}/server/job_queue/job`,
      { method: 'POST', body: queueData }
    );

      if (!enqueueRes.ok) {
        throw new Error(`Failed to enqueue job for printing. ${enqueueRes.status}`);
      }

    const startRes = await fetch(
      `https://${ip}/server/job_queue/start`,
      { method: 'POST' }
    );

      if (!startRes.ok) {
        throw new Error(`Failed to start job queue for printing. ${startRes.status}`);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to send G-code to printer: ${error.message}`);
      }

      throw new Error('Failed to send G-code to printer. The printer did not respond or the connection failed.');
    }
  }
}
